import { EscritoAdjuntosPost } from 'src/services/EscritosServices'

const getBlobFromBase64 = (file: EscritoAdjuntosPost): File => {
  const byteCharacters = atob(file.base64)
  const byteNumbers = new Array(byteCharacters.length)
  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }
  const byteArray = new Uint8Array(byteNumbers)
  const blob = new Blob([byteArray], { type: 'application/pdf' })
  return new File([blob], file.fileName, { type: 'application/pdf' })
}

export { getBlobFromBase64 }
